import { css } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';

const MIN_ICON_SIZE = 24;

export default class EnergyEfficiencyClassStyle {
	/**
	 * Returns styles.
	 *
	 * @param options ...
	 * @param options.energyType
	  ...
	 * @returns Styles.
	 */
	public static getStyle(options: { energyType: string | null }): string {
		const imageWidth = this.getImageWidth(options.energyType);
		return css`
			:host,
			kompis-focus-outline {
				display: flex;
			}
			kompis-energy-efficiency-non-rescaled,
			img {
				${imageWidth ? `width: ${imageWidth};` : ''};
				min-width: 2.5rem;
				flex-shrink: 0;
			}
			kompis-hyperlink {
				display: block;
			}
			.imageContainer {
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				min-height: ${MIN_ICON_SIZE / 16}rem;
				min-width: ${MIN_ICON_SIZE / 16}rem;
				outline: none;
			}
		`;
	}

	private static getImageWidth(energyType: string | null): string | null {
		switch (energyType) {
			case ProductComplianceTechnicalHeadingTypeEnum.energyEfficiencyClass:
				return '2.7em';
			case ProductComplianceTechnicalHeadingTypeEnum.hyperlink:
				return '100%';
			default:
				return null;
		}
	}
}
